import React from "react";
import CourseDetailTemplate from "./CourseDetailTemplate";
const CURRICULUM = [
  "MongoDB (Database Management and Aggregations)",
  "Express.js (Back-End Development)",
  "Angular (Front-End Framework)",
  "Node.js (Server-Side Development)",
  "RESTful API Development",
  "Deployment and DevOps (Docker, AWS, Heroku)",
  "Authentication, Authorization, and Security Best Practices",
];
const STRUCTURE = [
  { title: "Admission",                      desc: "Eligibility check and onboarding process." },
  { title: "Training / Learning — 3 Months", desc: "Intensive hands-on training with expert mentors." },
  { title: "Mock Interview",                 desc: "Score minimum 3.5 out of 5 to progress." },
  { title: "Live Project — 3 Months",        desc: "Work on real industry-grade projects." },
  { title: "Monthly Assessment & Report",    desc: "Track progress with regular evaluations." },
  { title: "Certification & Job Support",    desc: "Certification and job opening references." },
];
const MEAN = () => (
  <CourseDetailTemplate title="MEAN Stack Development Course"
    description="Master the MEAN stack to build robust, modern web applications! Learn MongoDB, Express.js, Angular, and Node.js from basics to advanced. Create scalable and efficient full-stack solutions."
    curriculum={CURRICULUM} structure={STRUCTURE}
    tags={["MongoDB", "Express.js", "Angular", "Node.js", "Docker"]}
    programName="MEAN Stack Development Course"
  />
);
export default MEAN;
